import React from "react";
import { Trans } from "react-i18next";
import { useHistory } from "react-router-dom";
import { Drawer, Tooltip } from "antd";
import { QuestionCircleOutlined, LoadingOutlined, PoweroffOutlined } from "@ant-design/icons";
import { MdAccessTime, MdLanguage, MdPhone, MdArrowBack } from "react-icons/md";
import { observer } from "mobx-react";
import classnames from "classnames";
import { PHONE_FORMAT, USER_STATES } from "../../constants";
import { getDirection } from "../../helpers";
import { useStore } from "../../store/rootStore";
import PhoneFormatSelect from "./components/PhoneFormatSelect";
import TimeFormatSelect from "./components/TimeFormatSelect";
import LanguageSelect from "./components/LanguageSelect";
import SecuritySettings from "./components/menu/Security";
import styles from "./SettingsDrawer.module.scss";
const UserSettingsDrawer = ({ isOpen, onClose }) => {
    const { loginStore } = useStore();
    const history = useHistory();
    const logOut = () => {
        if (loginStore.loading) {
            return;
        }
        loginStore
            .logOut()
            .then(() => {
            if (loginStore.userState === USER_STATES.LOGGED_OUT) {
                history.push("/login");
            }
        })
            .catch((error) => {
            console.error("Error logging out", error);
        });
    };
    const goToAppPath = (path) => {
        onClose();
        history.push(path, { prevPath: history.location.pathname });
    };
    const phoneFormatTooltipContent = (React.createElement("div", { className: styles.tooltipContent },
        React.createElement("div", null,
            React.createElement("strong", null,
                React.createElement(Trans, { i18nKey: PHONE_FORMAT.SMART }),
                ":"),
            React.createElement("br", null),
            React.createElement(Trans, { i18nKey: "PF_SMART_ABOUT" })),
        React.createElement("div", null,
            React.createElement("strong", null,
                React.createElement(Trans, { i18nKey: PHONE_FORMAT.INTERNATIONAL }),
                ":"),
            React.createElement("br", null),
            React.createElement(Trans, { i18nKey: "PF_INTERNATIONAL_ABOUT" })),
        React.createElement("div", null,
            React.createElement("strong", null,
                React.createElement(Trans, { i18nKey: PHONE_FORMAT.NATIONAL }),
                ":"),
            React.createElement("br", null),
            React.createElement(Trans, { i18nKey: "PF_NATIONAL_ABOUT" }))));
    return (React.createElement(Drawer, { className: classnames(styles.drawer, { [styles.rtl]: getDirection() === "rtl" }), onClose: onClose, placement: getDirection() === "rtl" ? "right" : "left", open: isOpen, width: 320, title: React.createElement(Trans, { i18nKey: "userSettings" }), bodyStyle: { padding: 0 }, closeIcon: React.createElement(MdArrowBack, { className: styles.closeIcon }), footerStyle: { padding: "8px 0", borderTop: "none" }, footer: React.createElement("button", { type: "button", className: styles.logoutButton, onClick: logOut, disabled: loginStore.loading, "aria-busy": loginStore.loading },
            loginStore.loading ? React.createElement(LoadingOutlined, null) : React.createElement(PoweroffOutlined, null),
            React.createElement(Trans, { i18nKey: "logout" })) },
        React.createElement("section", { className: styles.customSection },
            React.createElement("div", { className: styles.settingsGroup },
                React.createElement("div", { className: styles.settingsItem },
                    React.createElement("div", { className: styles.settingsItemContent },
                        React.createElement(MdLanguage, { className: styles.settingsIcon }),
                        React.createElement("span", { className: styles.settingsLabel },
                            React.createElement(Trans, { i18nKey: "Languages" }))),
                    React.createElement("div", { className: styles.settingsControl },
                        React.createElement(LanguageSelect, null))),
                React.createElement("div", { className: styles.settingsItem },
                    React.createElement("div", { className: styles.settingsItemContent },
                        React.createElement(MdAccessTime, { className: styles.settingsIcon }),
                        React.createElement("span", { className: styles.settingsLabel },
                            React.createElement(Trans, { i18nKey: "timeFormat" }))),
                    React.createElement("div", { className: styles.settingsControl },
                        React.createElement(TimeFormatSelect, null))),
                React.createElement("div", { className: styles.settingsItem },
                    React.createElement("div", { className: styles.settingsItemContent },
                        React.createElement(MdPhone, { className: styles.settingsIcon }),
                        React.createElement(Tooltip, { title: phoneFormatTooltipContent, placement: "top" },
                            React.createElement("div", { className: styles.sectionTitle },
                                React.createElement(Trans, { i18nKey: "phoneFormat" }),
                                React.createElement(QuestionCircleOutlined, null)))),
                    React.createElement("div", { className: styles.settingsControl },
                        React.createElement(PhoneFormatSelect, null)))),
            React.createElement(SecuritySettings, { goToAppPath: goToAppPath }))));
};
export default observer(UserSettingsDrawer);
